import { Component, ElementRef, inject, Input, Renderer2, SimpleChanges } from '@angular/core';
import { ThemeService } from '../../core/services/theme.service';

@Component({
  selector: 'shared-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  private readonly renderer2 = inject(Renderer2);
  private readonly element = inject(ElementRef) as ElementRef<HTMLElement>;
  protected readonly theme = inject(ThemeService);

  @Input()
  color: 'primary' | 'currentColor' = 'primary';

  @Input()
  appearance: 'spinner' | 'pulse' = 'pulse';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['color']) {
      const previousClass = 'loading-color--' + changes['color'].previousValue;
      const newClass = 'loading-color--' + changes['color'].currentValue;
      this.renderer2.removeClass(this.element.nativeElement, previousClass);
      this.renderer2.addClass(this.element.nativeElement, newClass);
    }
  }

  ngAfterViewInit(): void {
    this.renderer2.addClass(this.element.nativeElement, 'loading-color--' + this.color);
  }
}
